import { castArray, get } from 'lodash'

const getDefaultExpandedKeys = treeData => castArray(get(treeData, '[0].key'))

export default getDefaultExpandedKeys
